var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.33 75.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.49,3.51c-1.88-2.34-4.18-3.51-6.9-3.51-2.25,0-4.25.79-5.98,2.39C.87,3.99,0,6.01,0,8.45c0,1.88.62,3.56,1.84,5.06l15.66,19.46,10.85-13.48L15.49,3.51ZM62.5,61.93l-15.66-19.46-10.85,13.48,12.86,15.97c1.88,2.44,4.17,3.66,6.9,3.66,2.15,0,4.13-.84,5.91-2.54,1.79-1.69,2.68-3.7,2.68-6.05,0-1.88-.62-3.56-1.84-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.33,8.45c0,1.88-.62,3.56-1.84,5.06l-19.48,24.21-10.85,13.47-16.68,20.73c-1.88,2.44-4.18,3.66-6.9,3.66-2.15,0-4.13-.84-5.91-2.54-1.79-1.69-2.68-3.7-2.68-6.05,0-1.88.62-3.56,1.84-5.07l19.48-24.2,10.85-13.48L48.84,3.51c1.88-2.34,4.18-3.51,6.9-3.51,2.25,0,4.25.79,5.98,2.39,1.74,1.6,2.61,3.61,2.61,6.06Z",
    fill: "#ef0bb8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivixIcon);
export default __webpack_public_path__ + "static/media/divix-icon.95eda5b3bc57589f38756e182d1f80c1.svg";
export { ForwardRef as ReactComponent };